webpackJsonp([131683993344931],{

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FacebookIcon = function FacebookIcon() {
	  return _react2.default.createElement(
	    "svg",
	    { className: "icon facebook-icon", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
	    _react2.default.createElement("path", { d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" })
	  );
	};
	
	exports.default = FacebookIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MailIcon = function MailIcon() {
	  return _react2.default.createElement(
	    "svg",
	    { className: "icon mail-icon", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 22 18" },
	    _react2.default.createElement("path", { d: "M4,4H20a2,2,0,0,1,2,2V18a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V6A2,2,0,0,1,4,4Z", transform: "translate(-1 -3)" }),
	    _react2.default.createElement("polyline", { points: "21 3 11 10 1 3" })
	  );
	};
	
	exports.default = MailIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TwitterIcon = function TwitterIcon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "20",
	      height: "20",
	      fill: "none",
	      viewBox: "0 0 1200 1227",
	      className: "icon twitter-icon"
	    },
	    _react2.default.createElement("path", {
	      fill: "#fff",
	      d: "M714.163 519.284L1160.89 0h-105.86L667.137 450.887 357.328 0H0l468.492 681.821L0 1226.37h105.866l409.625-476.152 327.181 476.152H1200L714.137 519.284h.026zM569.165 687.828l-47.468-67.894-377.686-540.24h162.604l304.797 435.991 47.468 67.894 396.2 566.721H892.476L569.165 687.854v-.026z"
	    })
	  );
	};
	
	exports.default = TwitterIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(88);
	
	var _breadcrumbs = __webpack_require__(95);
	
	var _breadcrumbs2 = _interopRequireDefault(_breadcrumbs);
	
	var _markdown = __webpack_require__(8);
	
	var _markdown2 = _interopRequireDefault(_markdown);
	
	var _clockIcon = __webpack_require__(92);
	
	var _clockIcon2 = _interopRequireDefault(_clockIcon);
	
	var _mailIcon = __webpack_require__(312);
	
	var _mailIcon2 = _interopRequireDefault(_mailIcon);
	
	var _facebookIcon = __webpack_require__(160);
	
	var _facebookIcon2 = _interopRequireDefault(_facebookIcon);
	
	var _twitterIcon = __webpack_require__(163);
	
	var _twitterIcon2 = _interopRequireDefault(_twitterIcon);
	
	__webpack_require__(122);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Article = function (_React$Component) {
	  _inherits(Article, _React$Component);
	
	  function Article() {
	    _classCallCheck(this, Article);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Article.prototype.renderShareButtons = function renderShareButtons() {
	    var url = 'https://hive.fi' + this.props.location.pathname;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'share-buttons-container' },
	      _react2.default.createElement(
	        'a',
	        { href: 'https://twitter.com/share?url=' + url, target: '_blank', className: 'share-button unstyled' },
	        _react2.default.createElement(_twitterIcon2.default, null)
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.facebook.com/sharer/sharer.php?u=' + url, target: '_blank', className: 'share-button unstyled' },
	        _react2.default.createElement(_facebookIcon2.default, null)
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto:?subject=&body=' + url, className: 'share-button unstyled' },
	        _react2.default.createElement(_mailIcon2.default, null)
	      )
	    );
	  };
	
	  Article.prototype.renderImage = function renderImage(image) {
	    if (image) {
	      var _image$sizes = image.sizes,
	          src = _image$sizes.src,
	          srcSet = _image$sizes.srcSet,
	          title = _image$sizes.title;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'article-image-wrapper' },
	        _react2.default.createElement('img', { src: src, srcSet: srcSet, className: 'feature-image', alt: title })
	      );
	    }
	
	    return null;
	  };
	
	  Article.prototype.render = function render() {
	    var _props = this.props,
	        lang = _props.lang,
	        localization = _props.localization,
	        content = _props.content;
	
	    var image = this.renderImage(content.featureImage);
	
	    var parentPage = {
	      path: lang === 'fi' ? '/fi/uutiset' : '/en/news',
	      title: localization('global.articles')
	    };
	
	    var currentPage = { title: content.heading };
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'page-article-container' },
	      _react2.default.createElement(_breadcrumbs2.default, {
	        lang: lang,
	        localization: localization,
	        currentPage: currentPage,
	        parentPage: parentPage }),
	      _react2.default.createElement(
	        'h1',
	        null,
	        content.heading
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'date' },
	        _react2.default.createElement(_clockIcon2.default, { className: 'icon clock-icon' }),
	        _react2.default.createElement(
	          'time',
	          { className: 'created-at' },
	          content.createdAt
	        )
	      ),
	      image,
	      _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'article-social-wrapper-side' },
	          this.renderShareButtons()
	        ),
	        _react2.default.createElement(_markdown2.default, { content: content.body.body })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'article-social-wrapper-sticky' },
	        this.renderShareButtons()
	      )
	    );
	  };
	
	  return Article;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRouter.withRouter)(Article);
	module.exports = exports['default'];

/***/ }),

/***/ 73:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var heroFragment = exports.heroFragment = "** extracted graphql fragment **";
	
	var pageContentFragment = exports.pageContentFragment = "** extracted graphql fragment **";

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _article = __webpack_require__(322);
	
	var _article2 = _interopRequireDefault(_article);
	
	var _localization = __webpack_require__(46);
	
	__webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArticlePage = function (_React$Component) {
	  _inherits(ArticlePage, _React$Component);
	
	  function ArticlePage() {
	    _classCallCheck(this, ArticlePage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ArticlePage.prototype.render = function render() {
	    var article = this.props.data.contentfulNewsArticle;
	    var locale = article.node_locale;
	    var lang = locale === 'fi-FI' ? 'fi' : 'en';
	    var localization = (0, _localization.getLocalization)(this.props.data.globalLocalization, locale);
	
	    if (!article) {
	      return null;
	    } else {
	      return _react2.default.createElement(_article2.default, { content: article, localization: localization, lang: lang });
	    }
	  };
	
	  return ArticlePage;
	}(_react2.default.Component);
	
	exports.default = ArticlePage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-article-js-6459ddaabd737f120ccb.js